import React from 'react';
import { cn } from '../../lib/utils';

const Label = React.forwardRef(({ className, ...props }, ref) => (
 <label
 ref={ref}
 className={cn(
 'text-xs font-semibold uppercase tracking-widest text-foreground leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
 className
 )}
 {...props}
 />
));

Label.displayName = 'Label';

export default Label;

